var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"modal-container card-small card",class:{ 'w-75': _vm.large, 'w-50': !_vm.large }},[_c('div',{staticClass:"card"},[_vm._t("default")],2)])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }